<template>
  <v-card>
    <v-card-title>
      {{ $t('REPORTS.INVOICES_ALL_LINES') }}
    </v-card-title>

    <v-card-text>
      <v-menu
        ref="menuDateFrom"
        v-model="menuDateFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="dateFrom | dateFormat"
            :label="$t('TASK.DATE_FROM')"
            append-icon="mdi-calendar"
            clearable
            readonly
            role="button"
            autocomplete="nope"
            @click:clear="clear_from"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          ref="picker"
          v-model="dateFrom"
          type="month"
          min="1940-01-01"
          :max="dateTo || datetimeNow"
          first-day-of-week="1"
        ></v-date-picker>
      </v-menu>

      <v-menu
        ref="menuDateTo"
        v-model="menuDateTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="dateTo | dateFormat"
            :label="$t('TASK.DATE_TO')"
            append-icon="mdi-calendar"
            clearable
            readonly
            role="button"
            autocomplete="nope"
            @click:clear="clear_to"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          ref="picker"
          v-model="dateTo"
          type="month"
          :min="dateFrom || '1940-01-01'"
          :max="datetimeNow"
          first-day-of-week="1"
        ></v-date-picker>
      </v-menu>
    </v-card-text>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>
      <v-btn :disabled="exportPdfIsDisabled" @click="getInvoices">
        {{ $t('BUTTON.EXPORT') }}
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';
import { dateFormat } from '@/modules/_global/filters';
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  name: 'InvoicesAllLines',

  filters: {
    dateFormat
  },

  mixins: [downloadFile],

  data: () => ({
    datetimeNow: '',
    menuDateFrom: false,
    dateFrom: null,
    menuDateTo: false,
    dateTo: null
  }),

  created() {
    this.datetimeNow = moment().format('YYYY-MM-DD');
  },

  computed: {
    exportPdfIsDisabled() {
      return !this.dateFrom || !this.dateTo;
    }
  },

  methods: {
    ...mapActions('report', ['retrieveInvoicesAllLines']),

    getInvoices() {
      let params = {
        date_from: this.dateFrom,
        date_to: this.dateTo
      };

      return this.retrieveInvoicesAllLines({ params: params })
        .then(response => {
          let rootName = this.$t('REPORTS.INVOICES_ALL_LINES');
          let dateFrom = moment(this.dateFrom).format('MMYYYY');
          let dateTo = moment(this.dateTo).format('MMYYYY');

          this.downloadFile(response, `${rootName}_${dateFrom}_${dateTo}.xlsx`);
        })
        .catch(error => {
          this.$emit('error', error);
        });
    },

    clear_from() {
      this.dateFrom = null;
    },
    clear_to() {
      this.dateTo = null;
    }
  }
};
</script>
